var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaderboardIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.7 5.143A2.443 2.443 0 015.143 2.7h13.713a2.443 2.443 0 012.443 2.443v13.713a2.443 2.443 0 01-2.443 2.443H5.143A2.443 2.443 0 012.7 18.856V5.143zM5.143 1A4.143 4.143 0 001 5.143v13.713a4.143 4.143 0 004.143 4.143h13.713a4.143 4.143 0 004.143-4.143V5.143A4.143 4.143 0 0018.856 1H5.143zm13.251 7.671a.85.85 0 00-1.7 0v8.873a.85.85 0 101.7 0V8.671zM12 11.15c.469 0 .85.38.85.85v5.545a.85.85 0 01-1.7 0V12c0-.47.38-.85.85-.85zM7.303 6.453a.85.85 0 10-1.7 0v11.091a.85.85 0 001.7 0V6.454z",
    fill: "#B9BBC6"
  })));
}
export default SvgLeaderboardIcon;